import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { convexQuery } from "@convex-dev/react-query"
import { useQuery } from "@tanstack/react-query"
import type { Address } from "viem"

interface UserPortfolioStatsArgs {
	userAddress: Address
}

export function useUserPortfolioStats(args: Maybe<UserPortfolioStatsArgs>) {
	return useQuery({
		...convexQuery(api.indexer.public.getUserPortfolioStats, {
			userAddress: args?.userAddress ?? "",
		}),
		enabled: !!args,
	})
}
